const isInKioskMode = () => window.location.href.includes("kiosk.")

export default isInKioskMode